import {
  Main,
  Container,
  Description,
  ButtonFidMore,
  ContainerPlanos,
  ContainerDescriptions,
} from "./styles";
import React from 'react';
import Link from "next/link";
import { useState } from "react";
import { Card } from "./partials/card";
import { useAuth } from "@/hooks/useAuth";
import { Pagination } from "@mui/material";

export function Planos() {
  const {lastFive} = useAuth();
  const [index, setIndex] = useState(0);

  return (
    <Main>
      <Container>
        <ContainerDescriptions>
          <h1>PLANOS</h1>
          <Description>
            Os planos são instrumentos de planejamento de políticas públicas
            para a cidade do Rio de Janeiro e partem da premissa
            de que uma estratégia bem concebida resulta em uma implementação
            bem-sucedida nos diversos setores em que a prefeitura atua.
          </Description>
          <Description>
            Por exemplo, o Plano Municipal de Saúde organiza as ações da prefeitura 
            para melhoria do serviço de saúde no município, influenciando desde a forma 
            como é gerida a secretaria do tema até a instalação de uma unidade de saúde 
            no seu bairro. Ao lado, é possível visualizar os cinco últimos planos adicionados à plataforma.
          </Description>
          <Link href="/planos">
            <ButtonFidMore>
              <p>Saiba mais sobre os planos</p>
            </ButtonFidMore>
          </Link>
        </ContainerDescriptions>
        <ContainerPlanos>
          <Card plano={lastFive[index]} />
          <Pagination
            count={lastFive.length}
            size="large"
            color="primary"
            onChange={(e, value) => setIndex(value - 1)}
            sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
          />
        </ContainerPlanos>
      </Container>
    </Main>
  );
}